var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBars(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 46,
    viewBox: "0 0 47 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "data-icon": "menu",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Open menu") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.1367 46C35.8393 46 46.1367 35.7025 46.1367 23C46.1367 10.2975 35.8393 0 23.1367 0C10.4342 0 0.136719 10.2975 0.136719 23C0.136719 35.7025 10.4342 46 23.1367 46ZM14.764 15.7009C14.1921 15.7009 13.7285 16.1645 13.7285 16.7363C13.7285 17.3082 14.1921 17.7718 14.764 17.7718H31.0915C31.6634 17.7718 32.127 17.3082 32.127 16.7363C32.127 16.1645 31.6634 15.7009 31.0915 15.7009H14.764ZM13.7285 22.8671C13.7285 22.2952 14.1921 21.8316 14.764 21.8316H31.0915C31.6634 21.8316 32.127 22.2952 32.127 22.8671C32.127 23.4389 31.6634 23.9025 31.0915 23.9025H14.764C14.1921 23.9025 13.7285 23.4389 13.7285 22.8671ZM14.764 27.9663C14.1921 27.9663 13.7285 28.4299 13.7285 29.0018C13.7285 29.5737 14.1921 30.0373 14.764 30.0373H31.0915C31.6634 30.0373 32.127 29.5737 32.127 29.0018C32.127 28.4299 31.6634 27.9663 31.0915 27.9663H14.764Z",
    fill: "#87a7d9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBars);
export default __webpack_public_path__ + "static/media/bars.49eb10c18f70ba83a2028501b8ebc160.svg";
export { ForwardRef as ReactComponent };